import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PopupType } from 'src/app/core/models/common.models';
import { environment } from '../../../../../../environments/environment';
import { EventType, IPopupInputForm } from '../../../models/passport.models';
import { Profile } from '../../../models/profile.model';
import { EventReviewService } from '../../../services/event-review.service';
import { PassportService } from '../../../services/passport.service';
import { upperCase } from 'lodash-es';

@Component({
  selector: 'app-display',
  templateUrl: './display.component.html',
  styleUrls: ['./display.component.css', '../profile.component.css'],
})
export class DisplayComponent implements OnInit {
  @Input() profile: Profile;
  @Input() favouriteEvents: any;
  @Input() communityPassport: boolean;

  @Output() editProfile = new EventEmitter<any>();
  @Output() refreshEventState: EventEmitter<boolean> = new EventEmitter(false);

  public selectedEvent: any;
  public showEventDetails = false;
  public popupType = PopupType.EVENT_REVIEW;
  public apiURL = environment.apiURL;
  private communityUserId = 0;

  constructor(
    private readonly breakpointObserver: BreakpointObserver,
    private readonly passportService: PassportService,
    private readonly route: ActivatedRoute,
    private readonly eventReviewService: EventReviewService
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.communityUserId = Number(params.userId);
    })
  }

  handleEditClick(): void {
    console.log('here ', this.profile);
    this.editProfile.emit({
      value: 'edit-profile'
    });
  }

  routeToProfile(): void {
    console.log(this.profile);
    window.location.href = `${this.apiURL}userProfiles/${this.profile.userId}`;
  }

  isDesktopDevice(): boolean {
    return this.breakpointObserver.isMatched('(min-width: 768px)');
  }

  handleEventClick(event: any): void {
    console.log('event clicked: ', event);

    this.selectedEvent = event;
    this.showEventDetails = true;
  }

  togglePopupState(): void {
    this.showEventDetails = false;
  }

  handleFavoriteEventBadgeClick(stamp: any): void {
    console.log('event clicked: ', stamp);

    stamp.eventType = EventType[upperCase(stamp.eventType)];

    const eventReviewPromise = this.communityPassport
      ? this.passportService.getCommunityPassportReview(stamp.eventId, stamp.eventType, this.communityUserId)
      : this.passportService.getEventReview(stamp.eventId, stamp.eventType);

    eventReviewPromise.then(response => {
      if (response.error) {
        this.selectedEvent = stamp;
        this.showEventDetails = true;
      } else {
        this.selectedEvent = stamp;
        this.selectedEvent.review = response;
        this.showEventDetails = true;
      }
    }).catch(() => {
      this.selectedEvent = stamp;
      this.showEventDetails = true;
    });
  }

  public async handlePopupInputFormData(event: IPopupInputForm): Promise<void> {
    this.showEventDetails = false;

    if (event.popupForm.favoriteState) {
      const status = await this.eventReviewService.handleFavoriteEventState(event);
      this.refreshEventState.emit(status);
    } else {
      const response = await this.eventReviewService.handleEventReviewPopup(event);
      this.selectedEvent.review = response.review;
      this.showEventDetails = response.showPopup;
    }
  }
}
